<template>
  <div class="">
   <!-- <div  v-if="address && top != 1"  class="mb-3 d-flex flex-row align-items-center">
      <div class="address-box-icon token-box-icon">
        <img src="../../images/token/eth.png"/>
      </div>
      <div class="ml-3">
        <div class="address-box-left-title pt-2">Token Details</div>
        <div class="address-box-left-text pt-2">
          <div class="address-box-copy">{{queryAddress}}<Copy :data="queryAddress"/></div>
        </div>
      </div>
    </div>
    <div v-show="page=='showTop'" class="container-top">
      <div class="container-title">
        <span>Tokens</span>
        <span>Total {{totalTx}} txs (show 10,000 latest records)</span>
      </div>

      <div class="container-selectPage">
        <div class="change-page">
          <span>Show</span>
          <div @click.stop="showRecordPage=!showRecordPage" class="change-page-num">
            <span>{{nowRecordPage}}</span>
            <img src="../../images/transtion/arrow-bottom.png"/>
            <div v-show="showRecordPage" class="change-page-num-click">
              <span v-for="(item,index) in recordPage" :key="index"  @click.stop="actionSelectPage(item)">{{item.num}}</span>
            </div>
          </div>
          <span>Records</span>
        </div>
        <paginationSp :config="cfg_pagination" @reloadList="getList()" class="py-3"/>
      </div>

    </div> -->
    <table class="mt-4 bg-card main-table w-100 text-right">
      <tr class="text-break">
        <td class="pl-4 text-left text-middle-bond" style="width: 13%" >
          Epoch
        </td>
        <td class="text-left text-middle-bond" >
          Voter Reward
        </td>

        <td class="text-left text-middle-bond"  >
          Reward
        </td>

      </tr>
<!--      <tr class="hover-bg transTable">-->
      <tr v-for="(item,index) in data_onshow" :key="index" class="hover-bg transTable">
<!--        <td class="mb-none text-left d-flex flex-row align-items-center">-->
<!--          <div class="trans-success ml-4">-->
<!--            <span>-->
<!--             {{ (cfg_pagination.page_current - 1) * cfg_pagination.page_size + index + 1}}-->
<!--            </span>-->
<!--          </div>-->
<!--        </td>-->
        <td class="pl-4 text-left">
          <div class="trans-td-text">{{item.epoch}}</div>
        </td>
        <td class="text-left">
          <div class="trans-td-text">{{item.voterReward}} MAPO</div>
        </td>
        <td class="text-left">
          <div class="trans-td-text"> {{item.reward}} MAPO</div>
        </td>
      </tr>
    </table>
    <PaginationSpTwo style="display: block" :config="cfg_pagination" @reloadList="getList()" class="pt-5"/>

  </div>
</template>

<script>
import { Decimal } from 'decimal.js'
import PaginationSp from "@/views/_comp/pagination_sp";
import Copy from "@/views/_frame/copy";
import PaginationSpTwo from "@/views/_comp/paginationn_sp_two";

export default {
  name: 'RewardsTable',
  components: {PaginationSpTwo, Copy, PaginationSp},
  props: [
    'cfg',
    'page',
    'top'
  ],
  data() {
    return {
      queryAddress:'',
      address:'',//地址显示
      showImg:0,
      type: null,
      showRecordPage:false,//显示数据tab
      nowRecordPage:25,//当前显示数据
      recordPage:[
        {num:25},
        {num:50},
        {num:75},
        {num:100}
      ],//一页多少数据
      cfg_pagination: {
        'page_size': 25, //每页条目数量
        'page_current': 1, // 当前页
        'count_items': 0, //总个数，和总页数选填其一
        'btn_num': 5, // 按钮个数
        'turnpage_top': true, // 翻页时操作滚动置顶
        'count_pages':0, //总页数，和个页数选填其一 // 默认请给 0 值-便于首次加载时不露出分页器
      },
      data_onshow: [],
      totalTx:0,//总数
      contract:'',
    }
  },
  computed: {},
  watch: {},
  methods: {
    //跳转地址
    goAddress(item) {
      var address= item.address
      this.$router.push(
          {
            path:"/address",
            query:{address:address}
          }
      )
    },
    //选择当前一页多少数据
    actionSelectPage(item) {
      let v = this
      v.nowRecordPage=item.num
      v.cfg_pagination.page_size=item.num
      v.showRecordPage=false
      // console.log(v.showRecordPage)
      v.initData()
    },
    initData(){
      let v = this

      // if(!v.data)return

      v.cfg_pagination.page_current = 1

      if(v.cfg){
        v.cfg_pagination.page_size = v.cfg.page_size
        v.cfg_pagination.page_current = v.cfg.page_current
      }

      // 过滤数据
      v.getList()
    },
    async getList(){
      let v = this
      // 过滤条目
      let start = v.cfg_pagination.page_current
      let end = v.cfg_pagination.page_size

      if(v.queryAddress){
        v.address = v.queryAddress
      }

      let params = {
        page: start,
        size: end,
        address : v.address,
      }

      let result = await v.api('queryRewardList', params, {
        vue: v,
        key_data: 'data',
      })
      if (result.code==200) {
        v.data_onshow = result.data.list
        v.totalTx = result.data.total
      }
      // 计算页码
      if(v.totalTx < 10000){
        v.cfg_pagination.count_pages = Math.ceil(v.totalTx/v.cfg_pagination.page_size)
      }else{
        v.cfg_pagination.count_pages = Math.ceil(10000/v.cfg_pagination.page_size)
      }

      // console.log( v.cfg_pagination.count_pages)

      // console.log(v.data_onshow)


    },
  },
  created() {
    if(this.address){
      this.queryAddress = this.address
    }else{
      this.queryAddress = this.$route.params.number
    }
    this.initData()
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
</style>
